const id_master_finance_category = {
    "": "kategori finance",
    add: "tambah kategori",
    edit: "ubah kategori",
    code: "kode kategori",
    name: "nama kategori",

    error: {
        code: "Kode kategori tidak boleh kosong.",
        name: "Nama kategori tidak boleh kosong.",
        coa: "COA kategori tidak boleh kosong.",
        create: "Gagal membuat kategori.",
        delete: "Gagal menghapus kategori.",
        edit: "Gagal mengubah kategori.",
    },

    success: {
        create: "Berhasil membuat kategori.",
        delete: "Berhasil menghapus kategori.",
        edit: "Berhasil mengubah kategori.",
    }
}

export default id_master_finance_category;